import { call, put, takeLatest } from "redux-saga/effects";
import request from "utils/request";
import { LeadsOptedInTasActions } from "./index";
import { showToast } from "components/ToastContainer/index";

function* fetchLeadsOptedInListSaga(action) {
  try {
    const {
      page = 1,
      limit = 10,
      search = "",
      company_id
    } = action.payload || {};

    const queryParams = new URLSearchParams({ page, limit });
    if (search) queryParams.append("search", search);
    if (company_id) queryParams.append("company_id", company_id);

    const response = yield call(
      request,
      `/api/leads-opted-in-tas?${queryParams.toString()}`,
      {
        method: "GET",
        credentials: "include"
      }
    );

    if (response.success) {
      yield put(
        LeadsOptedInTasActions.fetchLeadsOptedInListSuccess(response.data)
      );
    }
  } catch (error) {
    yield put(LeadsOptedInTasActions.fetchLeadsOptedInListError(error.message));
  }
}

function* createLeadsOptedInSaga(action) {
  try {
    const response = yield call(request, `/api/create-leads-opted-in-tas`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(action.payload)
    });

    if (response.success) {
      showToast("Company opted in successfully.", "success");
      yield put(LeadsOptedInTasActions.createLeadsOptedInSuccess());
    } else {
      yield put(
        LeadsOptedInTasActions.createLeadsOptedInError(response.message)
      );
    }
  } catch (error) {
    showToast(error.message, "danger");
    yield put(LeadsOptedInTasActions.createLeadsOptedInError(error.message));
  }
}

function* reOptInSaga(action) {
  try {
    const { id } = action.payload;

    const response = yield call(
      request,
      `/api/leads-opted-in-tas/${id}/re-optin`,
      {
        method: "POST",
        credentials: "include"
      }
    );

    if (response.success) {
      showToast("Company re-opted in successfully.", "success");
      yield put(LeadsOptedInTasActions.reOptInSuccess());
    } else {
      yield put(LeadsOptedInTasActions.reOptInError(response.message));
    }
  } catch (error) {
    showToast(error.message, "danger");
    yield put(LeadsOptedInTasActions.reOptInError(error.message));
  }
}

function* updateLeadsOptedInSaga(action) {
  try {
    const { id, ...body } = action.payload;

    const response = yield call(request, `/api/leads-opted-in-tas/${id}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

    if (response.success) {
      showToast("Record updated successfully.", "success");
      yield put(LeadsOptedInTasActions.updateLeadsOptedInSuccess());
    } else {
      yield put(
        LeadsOptedInTasActions.updateLeadsOptedInError(response.message)
      );
    }
  } catch (error) {
    showToast(error.message, "danger");

    yield put(LeadsOptedInTasActions.updateLeadsOptedInError(error.message));
  }
}

function* deleteLeadsOptedInSaga(action) {
  try {
    const { id, reason } = action.payload;

    const response = yield call(
      request,
      `/api/leads-opted-in-tas-delete/${id}`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reason }) // reason mandatory
      }
    );

    if (response.success) {
      showToast("Record updated successfully.", "success");
      yield put(LeadsOptedInTasActions.deleteLeadsOptedInSuccess());
    } else {
      yield put(
        LeadsOptedInTasActions.deleteLeadsOptedInError(response.message)
      );
    }
  } catch (error) {
    showToast(error.message, "danger");

    yield put(LeadsOptedInTasActions.deleteLeadsOptedInError(error.message));
  }
}

export function* leadsOptedInTasSaga() {
  yield takeLatest(
    LeadsOptedInTasActions.fetchLeadsOptedInList.type,
    fetchLeadsOptedInListSaga
  );
  yield takeLatest(
    LeadsOptedInTasActions.createLeadsOptedIn.type,
    createLeadsOptedInSaga
  );
  yield takeLatest(LeadsOptedInTasActions.reOptIn.type, reOptInSaga);
  yield takeLatest(
    LeadsOptedInTasActions.updateLeadsOptedIn.type,
    updateLeadsOptedInSaga
  );
  yield takeLatest(
    LeadsOptedInTasActions.deleteLeadsOptedIn.type,
    deleteLeadsOptedInSaga
  );
}
